import React from "react";
import Modal from "react-bootstrap4-modal";
import { BeatLoader } from "react-spinners";

const STATUS_CONFIG = {
  match:   { icon: "fa fa-check-circle",      color: "#5cb85c", label: "Confere" },
  partial: { icon: "fa fa-exclamation-circle", color: "#f0ad4e", label: "Parcial" },
  missing: { icon: "fa fa-question-circle",    color: "#aaa",    label: "Não encontrado" },
  mismatch:{ icon: "fa fa-times-circle",       color: "#d9534f", label: "Divergência" },
};

var MIN_SCORE_TO_PROCEED = 70;

// A validação da imagem do contrato por IA é opcional e só é executada quando
// REACT_APP_VALIDACAO_IA=true no arquivo .env do ambiente.
export const VALIDACAO_IA_HABILITADA = process.env.REACT_APP_VALIDACAO_IA === "true";

function scoreBgColor(score) {
  if (score >= 90) return "#5cb85c";
  if (score >= 60) return "#f0ad4e";
  return "#d9534f";
}

function FieldScoreBar({ score }) {
  if (score == null) return null;
  var color = score >= 100 ? "#5cb85c" : score >= 50 ? "#f0ad4e" : "#d9534f";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
      <div style={{ flex: 1, background: "#e8e8e8", borderRadius: 3, height: 6, overflow: "hidden" }}>
        <div style={{ width: score + "%", background: color, height: "100%", borderRadius: 3, transition: "width 0.3s" }} />
      </div>
      <span style={{ fontSize: "0.75em", color: color, fontWeight: "bold", minWidth: 32, textAlign: "right" }}>
        {score}/100
      </span>
    </div>
  );
}

function FieldCard({ field }) {
  var cfg = STATUS_CONFIG[field.status] || STATUS_CONFIG.missing;
  return (
    <div style={{
      borderLeft: "4px solid " + cfg.color,
      background: "#fafafa",
      borderRadius: 4,
      padding: "8px 12px",
      marginBottom: 6,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 4 }}>
        <strong style={{ fontSize: "0.9em" }}>{field.label || field.name}</strong>
        <span style={{ color: cfg.color, fontSize: "0.85em", whiteSpace: "nowrap" }}>
          <i className={cfg.icon} style={{ marginRight: 4 }} />{cfg.label}
        </span>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4, fontSize: "0.82em", color: "#555" }}>
        <span><strong>Esperado:</strong> {field.expected != null && field.expected !== "" ? String(field.expected) : <em>—</em>}</span>
        <span><strong>Encontrado:</strong> {field.found != null && field.found !== "" ? String(field.found) : <em>—</em>}</span>
      </div>
      {field.reason && (
        <div style={{ marginTop: 3, fontSize: "0.78em", color: "#777" }}>{field.reason}</div>
      )}
      <FieldScoreBar score={field.fieldScore} />
    </div>
  );
}

function VehicleSection({ vehicle, index }) {
  var fields = vehicle.fields || [];
  return (
    <div style={{ marginTop: 8, marginBottom: 4 }}>
      <div style={{ fontWeight: "bold", fontSize: "0.88em", marginBottom: 4, color: "#444" }}>
        Veículo {index + 1}
      </div>
      {fields.map(function (f, i) {
        return <FieldCard key={i} field={f} />;
      })}
    </div>
  );
}

class ValidacaoIAModal extends React.Component {
  render() {
    var { open, loading, result, onProceed, onCancel } = this.props;
    var score = result && !result.skipped && result.score != null ? result.score : null;

    // Envio bloqueado quando o score está abaixo do mínimo exigido.
    var blocked = score != null && score < MIN_SCORE_TO_PROCEED;

    var proceedBtnCls = "btn btn-primary";
    if (blocked) proceedBtnCls = "btn btn-danger";
    else if (score != null && score < 60) proceedBtnCls = "btn btn-warning";
    else if (score != null && score >= 90) proceedBtnCls = "btn btn-success";

    return (
      <Modal visible={!!open} onClickBackdrop={loading ? undefined : onCancel}>
        <div className="modal-header" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
          <h5 className="modal-title" style={{ margin: 0, fontSize: "1em", display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa fa-search" />
            Validação da Imagem por IA
          </h5>
          {score != null && (
            <span style={{
              background: scoreBgColor(score),
              color: "#fff",
              borderRadius: 4,
              padding: "4px 10px",
              fontWeight: "bold",
              fontSize: "0.95em",
              marginLeft: "auto",
            }}>
              Score: {score}
            </span>
          )}
        </div>

        <div className="modal-body" style={{ maxHeight: "65vh", overflowY: "auto", padding: "12px 16px" }}>
          {loading && (
            <div style={{ textAlign: "center", padding: "30px 0" }}>
              <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />
              <p style={{ marginTop: 12, color: "#888", fontSize: "0.9em" }}>Analisando imagem com IA, aguarde...</p>
            </div>
          )}

          {!loading && result && result.skipped && (
            <div className="alert alert-warning" style={{ fontSize: "0.9em" }}>
              <i className="fa fa-exclamation-triangle" /> <strong>Validação indisponível:</strong>{" "}
              {result.reason || "Serviço de IA temporariamente indisponível."}
              <br />
              <small>Você pode prosseguir com o envio normalmente.</small>
            </div>
          )}

          {!loading && result && !result.skipped && (
            <div>
              {result.summary && (
                <div className="alert alert-info" style={{ fontSize: "0.88em", padding: "8px 12px", marginBottom: 12 }}>
                  <i className="fa fa-info-circle" /> {result.summary}
                </div>
              )}

              {result.fields && result.fields.length > 0 && (
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "0.88em", color: "#444", marginBottom: 6 }}>
                    Campos do Contrato
                  </div>
                  {result.fields.map(function (f, i) {
                    return <FieldCard key={i} field={f} />;
                  })}
                </div>
              )}

              {result.vehicles && result.vehicles.length > 0 && (
                <div style={{ marginTop: 14 }}>
                  <div style={{ fontWeight: "bold", fontSize: "0.88em", color: "#444", marginBottom: 6 }}>
                    Veículos
                  </div>
                  {result.vehicles.map(function (v, i) {
                    return <VehicleSection key={i} vehicle={v} index={v.index != null ? v.index : i} />;
                  })}
                </div>
              )}

              {blocked && (
                <div className="alert alert-danger" style={{ marginTop: 12, fontSize: "0.88em" }}>
                  <i className="fa fa-ban" /> <strong>Envio bloqueado:</strong> o score está abaixo do mínimo exigido
                  ({MIN_SCORE_TO_PROCEED}). Há divergências significativas entre o PDF e os dados do contrato. Corrija a
                  imagem ou os dados do contrato e valide novamente para prosseguir.
                </div>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer" style={{ padding: "10px 16px" }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          {!loading && (
            <button
              type="button"
              className={proceedBtnCls + " btn-sm"}
              onClick={blocked ? undefined : onProceed}
              disabled={blocked}
              title={blocked ? "Score abaixo de " + MIN_SCORE_TO_PROCEED + " — envio não permitido." : undefined}
            >
              {blocked
                ? "Envio bloqueado (score < " + MIN_SCORE_TO_PROCEED + ")"
                : score != null && score < 60
                ? "Prosseguir mesmo assim"
                : "Prosseguir com envio"}
            </button>
          )}
        </div>
      </Modal>
    );
  }
}

export default ValidacaoIAModal;
